if (!customElements.get("featured-collection-slider")) {
  class FeaturedCollectionSlider extends HTMLElement {
    selectors = {
      slider: "[js-slider]",
      prev: "[js-prev]",
      next: "[js-next]",
    };

    config = {
      slidesPerView: "auto",
      slidesPerGroup: 2,
      spaceBetween: 12,
    };

    constructor() {
      super();
    }

    init() {
      let slidesDesktop =
        this.getAttribute("data-slides-per-view-desktop") ?? 5;
      let slidesPerGroup =
        this.getAttribute("data-slides-per-group-desktop") ??
        this.getAttribute("data-slides-per-view-desktop") ??
        6;

      if (window.location.pathname.includes("/account")) {
        slidesDesktop = 4;
        slidesPerGroup = 4;
      }

      this.swiperInstance = new Swiper(
        this.querySelector(this.selectors.slider),
        {
          ...this.config,
          breakpoints: {
            1050: {
              slidesPerView: Number(slidesDesktop),
              slidesPerGroup: Number(slidesPerGroup),
            },
          },
          navigation: {
            prevEl: this.querySelector(this.selectors.prev),
            nextEl: this.querySelector(this.selectors.next),
          },
        }
      );
    }

    connectedCallback() {
      this.sliderElement = this.querySelector(this.selectors.slider);

      if (!this.sliderElement) return;

      window.setTimeout(() => {
        if (!this.hasAttribute("js-await-init")) this.init();
      }, 200);

      this.addEventListener(
        "featured-collection-slider:init",
        this.init.bind(this)
      );
    }
  }

  customElements.define("featured-collection-slider", FeaturedCollectionSlider);
}
